var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.2,
    height: 30.2,
    viewBox: "0 0 30.2 30.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Question_3747909",
    transform: "translate(-8.9 -8.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    d: "M24,39.1A15.1,15.1,0,1,1,39.1,24,15.1,15.1,0,0,1,24,39.1Zm0-27.68A12.58,12.58,0,1,0,36.58,24h0A12.58,12.58,0,0,0,24,11.42Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    d: "M26.7,24.53c-1.23.88-1.79,1.74-1.69,2.58v.59H22.35v-.81a4.09,4.09,0,0,1,1.85-3.46c1.27-.93,1.89-1.8,1.84-2.58a1.79,1.79,0,0,0-1.82-1.77h0a2.53,2.53,0,0,0-2.5,1.86,1,1,0,0,1-1.1.59l-1.05-.24a1,1,0,0,1-.7-1.23q1.21-3.69,5.79-3.56,4.27.22,4.64,3.91.15,2.36-2.58,4.12Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_699",
    width: 3.24,
    height: 3.02,
    rx: 0.96,
    transform: "translate(22.06 29.1)",
    fill: "#ccc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.cf013f69.svg";
export { ForwardRef as ReactComponent };